'use client';

import type { IStepCount } from '@repo/sdk';
import { Badge } from '@repo/ui';
import { Check, Circle } from 'lucide-react';
import type { JSX } from 'react';

interface IPipelineStepCountBadgeProps {
  step: IStepCount;
}

export function PipelineStepCountBadge({ step }: IPipelineStepCountBadgeProps): JSX.Element {
  if (step.ranAt === null) {
    return (
      <Badge variant="outline" className="text-muted-foreground gap-1">
        <Circle className="size-3" />-
      </Badge>
    );
  }

  return (
    <Badge variant="default" className="bg-green-600 text-white gap-1">
      <Check className="size-3" />
      {step.count}
    </Badge>
  );
}
